import { IAppContextActions } from 'contexts/App/types'
import { json } from '../RequestService'
import { IBaseResponse } from '../RequestService/Response'
import {
  IGetBotsGroupsRequest,
  IGetBotsGroupsResponse,
  IGetBotsNamesResponse,
  IGetFlowRequest,
  IGetFlowResponse,
  IGetPublishBackupResponse,
  ISavePublishBackupResponse,
} from './types'

const proxyApiUrl = process.env.REACT_APP_PROXY_URL

const baseUrl = 'bots'

export const GetBotsGroups = async (
  request: IGetBotsGroupsRequest,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<IGetBotsGroupsResponse>> => {
  const action = `${baseUrl}/${request.bot_name}/groups/names`
  return await json<IGetBotsGroupsResponse>('GET', action, dispatch)
}

export const GetBotsNames = async (
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<IGetBotsNamesResponse>> => {
  const action = `${baseUrl}/names`
  return await json<IGetBotsNamesResponse>('GET', action, dispatch)
}

export const GetFlows = async (
  request: IGetFlowRequest,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<IGetFlowResponse>> => {
  const action = `${baseUrl}/${request.bot_name}`
  return await json<IGetFlowResponse>('GET', action, dispatch)
}

export const GetPublishBackup = async (
  bot_name: string,
  dispatch: React.Dispatch<IAppContextActions>,
  skip = '0',
  limit = '5',
): Promise<IBaseResponse<IGetPublishBackupResponse>> => {
  const action = `bots/${bot_name}/backup?skip=${skip}&limit=${limit}`
  return await json<IGetPublishBackupResponse>(
    'GET',
    action,
    dispatch,
    undefined,
    undefined,
    { baseUrl: proxyApiUrl },
  )
}

export const SavePublishBackup = async (
  botName: string,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<ISavePublishBackupResponse>> => {
  const action = `bots/${botName}/backup`
  return await json<ISavePublishBackupResponse>(
    'POST',
    action,
    dispatch,
    undefined,
    undefined,
    { baseUrl: proxyApiUrl },
  )
}

export const RollbackBackup = async (
  botName: string,
  backupId: string,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<any>> => {
  const action = `bots/${botName}/backup/${backupId}/revert`
  return await json<any>('PUT', action, dispatch, undefined, undefined, {
    baseUrl: proxyApiUrl,
  })
}
